import { IdoFavorite } from 'src/models/organization';

import { Callback } from 'src/util/query/models/Callback';

export class GetTheFavoriteIdosForTheUserQueryCallBack extends Callback<Array<IdoFavorite>> {
	public constructor(private readonly setIdoFavorites: (idoFavorites: Array<IdoFavorite>) => void) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
	};

	successCallbackFunction = (successResponse: Array<IdoFavorite>): void => {
		this.setIdoFavorites(successResponse);
	};
}
